import React from 'react';
import './UpdatesButton.css';

const UpdatesButton = ({ toggleSidebar }) => {
  return (
    <button className="updates-button" onClick={toggleSidebar}>
      <span className="pulse-dot"></span>
      <span className="button-text">Live Updates</span>
    </button>
  );
};

export default UpdatesButton; 